import { CollateralStatus, EntityStatus } from 'api'
import * as constants from 'view/styles/constants'
import { Locale, Translation } from 'locale'

export function getEntityStatusColor(status: EntityStatus): string {
  switch (status) {
    case EntityStatus.ENABLED:
      return constants.STATUS_COLOR_READY
    case EntityStatus.DISABLED:
      return constants.STATUS_COLOR_DEFAULT
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}

export function getCollateralStatusColor(status: CollateralStatus): string {
  switch (status) {
    case CollateralStatus.ENABLED:
      return constants.STATUS_COLOR_READY
    case CollateralStatus.PENDING:
    case CollateralStatus.PENDING_FAILED:
    case CollateralStatus.PENDING_AWAITING_PRICE:
    case CollateralStatus.DISABLED:
      return constants.STATUS_COLOR_DEFAULT
    case CollateralStatus.READY_FOR_ACTIVATION:
      return constants.STATUS_COLOR_INACTIVE
    default:
      throw new Error(`Unhandled collateral status [${status}]`)
  }
}

export function getEntityStatusActiveSuspendedText(status: EntityStatus): string {
  switch (status) {
    case EntityStatus.ENABLED:
      return Locale.translate(Translation.TC_ACTIVE)
    case EntityStatus.DISABLED:
      return Locale.translate(Translation.TC_SUSPENDED)
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}

export function getCollateralStatusActiveSuspendedText(status: CollateralStatus): string {
  switch (status) {
    case CollateralStatus.PENDING:
      return Locale.translate(Translation.TC_PENDING)
    case CollateralStatus.PENDING_FAILED:
      return Locale.translate(Translation.TC_PENDING_FAILED)
    case CollateralStatus.PENDING_AWAITING_PRICE:
      return Locale.translate(Translation.TC_PENDING_AWAITING_PRICE)
    case CollateralStatus.ENABLED:
      return Locale.translate(Translation.TC_ACTIVE)
    case CollateralStatus.DISABLED:
      return Locale.translate(Translation.TC_SUSPENDED)
    case CollateralStatus.READY_FOR_ACTIVATION:
      return Locale.translate(Translation.TC_RFA)
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}

export function getEntityStatusEnabledDisabledText(status: EntityStatus): string {
  switch (status) {
    case EntityStatus.ENABLED:
      return Locale.translate(Translation.TC_ENABLED)
    case EntityStatus.DISABLED:
      return Locale.translate(Translation.TC_DISABLED)
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}
